import useAuth from '@app/auth/use-auth';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import { cn } from '@shared/lib/utils';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';

interface NumberProductAndIngredientsProps {
  numProducts: number;
  numIngredients: number;
}

const NumberProductAndIngredients: FC<NumberProductAndIngredientsProps> = ({
  numProducts,
  numIngredients,
}) => {
  const { user } = useAuth();
  const location = useLocation();
  return (
    <div
      className={cn(
        'flex flex-col w-full justify-start items-start space-x-0 rounded-r-lg bg-gray-00 ',
        {
          'md:flex-row md:justify-start md:items-center space-x-0 lg:pl-1 lg:space-x-6':
            user!.productCategory === 'dish',
        }
      )}
    >
      <div className="flex p-6 sm:pl-4">
        <div className="ml-4 mr-8 flex size-11 items-center justify-center rounded-full bg-gray-25 p-3">
          <Icons.salad />
        </div>
        <div>
          <Text className="text-nowrap text-xs">No. of Products</Text>
          <div className="flex flex-nowrap">
            <Text className="mt-1 text-nowrap text-2xl font-bold">
              {numProducts}
              {user!.organizationProductLimit &&
                !location.pathname.includes('collection') &&
                ` / ${user!.organizationProductLimit}`}
            </Text>
          </div>
        </div>
      </div>
      <div className="flex p-4 sm:pl-4">
        <div className="ml-4 mr-8 flex size-11 items-center justify-center rounded-full bg-gray-25 p-3">
          <Icons.sprout />
        </div>
        <div>
          <Text className="text-nowrap text-xs">No. of Ingredients</Text>
          <Text className="mt-1 text-nowrap text-2xl font-bold">
            {numIngredients}
          </Text>
        </div>
      </div>
    </div>
  );
};

export default NumberProductAndIngredients;
